import { render, staticRenderFns } from "./loadingspinner.vue?vue&type=template&id=676b34f7&scoped=true&"
import script from "./loadingspinner.vue?vue&type=script&lang=js&"
export * from "./loadingspinner.vue?vue&type=script&lang=js&"
import style0 from "./loadingspinner.vue?vue&type=style&index=0&id=676b34f7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676b34f7",
  null
  
)

export default component.exports